export default "__VITE_ASSET__DsSa2Hr___"